import createTemplateService from './createTemplateServjce';
const presentationTemplateService = createTemplateService('/presentation_templates');
export default presentationTemplateService;